
import Input from '../../shared/input';
import IconButton from '../../../../icon-button';
import { IconButtonProperty, IconButtonPropsEventType } from '../../../../icon-button/enums';
import { IconType } from '../../../../icon/enums';
import {
  InputProperty,
  InputEventType,
  InputType,
  InputSlotType,
  InputFillType,
} from '../../shared/input/enums';
import IncrementInputProps from './mixins/IncrementInputProps';
import { IncrementInputProperty } from './enums';
import { ControlEventType } from '../../enums';
import StylesMixin from '../../../../../mixins/styles';

export default {
  name: 'IncrementInput',
  components: {
    Input,
    IconButton,
  },
  mixins: [StylesMixin, IncrementInputProps],
  data() {
    return {
      InputProperty,
      InputEventType,
      InputSlotType,
      InputType,
      IncrementInputProperty,
      IconButtonProperty,
      IconButtonPropsEventType,
      IconType,
      InputFillType,
    };
  },
  computed: {
    displayValue() {
      const number = Number(this[IncrementInputProperty.Value]);

      return number || 0;
    },
    isDecreaseButtonDisabled() {
      return this[IncrementInputProperty.Value] <= this[IncrementInputProperty.Min];
    },
    isIncreaseButtonDisabled() {
      return this[IncrementInputProperty.Value] >= this[IncrementInputProperty.Max];
    },
  },
  methods: {
    handleInputFocus(event) {
      this.$emit(ControlEventType.Focus, event.target.value);
    },
    handleInputBlur(event) {
      this.$emit(ControlEventType.Blur, event.target.value);
    },
    handleDecreaseButtonClick() {
      this.$emit(ControlEventType.Change, this.displayValue - this[IncrementInputProperty.Step]);
    },
    handleIncreaseButtonClick() {
      this.$emit(ControlEventType.Change, this.displayValue + this[IncrementInputProperty.Step]);
    },
  },
};
